<template>
  <section>
    <header>
      <h1 class="page-header">Help / Should You Bluff</h1>
    </header>
    <p>Check out the videos in the playlist below:</p>
    <section class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rMORHUibOfufweZL8ki9s" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </section>
    <h3>Still need help?</h3>
    <p>I'm here for you. Hit me up at <a href="maillto:contact@sixplusholdem.com">contact@sixplusholdem.com</a>. I'd love to answer any questions you have.</p>
  </section>
</template>

<script>
export default {
  name: 'should-you-bluff-help',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/help/should-you-bluff-help.vue